import React from 'react'
import PropTypes from 'prop-types'
import PillCustom from "../../../../gd-components/molecules/pill/pill-custom";

export default function RatingOptionPill(props:any) {
    if (!props.option) return null

    const stars = new Array(props.scale).fill(true).fill(false, props.option.value);

    return (
        <PillCustom size={26} palette="gray" value={props.option} onClick={props.onClick} onDelete={props.onDelete} className="m-t-4 m-b-4 m-r-4">

            <div className="ui5-selector-rating">
                {_.map(stars, (value, key)=>{
                    const classes = Classes("icon", {
                        'filled i5-star'       : value,
                        'empty i5-star-empty'  : !value,
                    })
                    return <div key={key} className={classes}/>
                })}
            </div>

        </PillCustom>
    )

}

RatingOptionPill.propTypes = {
    size    : PropTypes.oneOf(['26', '22']),
    scale   : PropTypes.number,
    option  : PropTypes.object,

    onClick : PropTypes.func,
    onDelete: PropTypes.func
}

RatingOptionPill.defaultProps = {
    size    : '26'
}